var React = require('react');

function IcoArrowRightYellowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m15.853 4-.281.281 7.369 7.369H0v.4h22.941l-7.369 7.369.281.281 7.848-7.848z","fill":"#FFBD00","fillRule":"nonzero","stroke":"#FFBD00","strokeWidth":".5"}));
}

IcoArrowRightYellowInline.defaultProps = {"width":"24","height":"24"};

module.exports = IcoArrowRightYellowInline;

IcoArrowRightYellowInline.default = IcoArrowRightYellowInline;
